import { DefaultCachingNumberFormatter as NumberFormatter } from '@square/dashboard-translations/utils/field-kit/default-caching-number-formatter';
export default class BitcoinCurrencyFormatter extends NumberFormatter {
  constructor() {
    super();
    this.setNumberStyle(NumberFormatter.Style.CURRENCY).setMaximumFractionDigits(8).setMinimumFractionDigits(0).setPositivePrefix('').setPositiveSuffix(' BTC').setNegativePrefix('-').setNegativeSuffix(' BTC');
  }
}
export const BITCOIN_TO_SATOSHI = 100_000_000;